<template>
  <div>

    <v-menu
      v-if="is_review_optimization_needed"
      class="review-optimization-dropdown"
      :disabled="$store.getters.isDemoUser"
      offset-x
      offset-y
      style="border: 1px solid var(--v-gray12Color-base);"
      rounded
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          :loading="loading"
          block
          rounded outlined :x-small="$vuetify.breakpoint.lgAndDown && !isInCard" :small="isInCard"
          color="mainColor"
          :class="{'button-with-icon text-none review-optimization-button': true, 'in-progress': activeOrder?.fulfillement_status === 'in_progress'}"
          style="position: relative;"
          v-bind="attrs"
          v-on="on"
        >
          <span class="material-icons-outlined mr-1 diamond-icon" style="font-weight: initial;">diamond</span>  
          <template v-if="activeOrder?.order_status === 'paid' && ['completed'].includes(activeOrder?.fulfillement_status)">
            <div class="btn-dot" style="display: inline-block; width: 9px; height: 9px; background-color: #11A33D; border-radius: 100%; position: absolute; top: -9px; right: -4px;"></div>
            <span style="font-weight: 700;">Show review</span>
          </template>
          <template v-else-if="activeOrder?.order_status === 'paid' && ['pending', 'in_progress'].includes(activeOrder?.fulfillement_status)">
            <div class="btn-dot" style="display: inline-block; width: 9px; height: 9px; background-color: #FF4040; border-radius: 100%; position: absolute; top: -9px; right: -4px;"></div>
            <div v-if="isInCard" class="btn-text" style="font-weight: 700; max-width: 200px; text-wrap: wrap;">Premium optimization review in progress</div>
            <div v-else style="font-weight: 700;" class="btn-text">Premium optimization review in progress</div>
          </template>
          <template v-else>
            <span style="font-weight: 700;">Premium optimization review</span>
          </template>

          <span v-if="new Date() < new Date('2026-06-09T23:59:59') && !activeOrder?.order_status === 'paid'" class="ml-1" style="background-color: #FFEDDD; border: 1px solid #FF5700; color: #FF5700; border-radius: 6px; padding: 3px 4px; line-height: 0.85;">
            NEW
          </span>
        </v-btn>
      </template>
      <v-list>
        <v-list-item style="width: 390px;">
          <div style="padding: 8px;">

            <template v-if="activeOrder?.order_status !== 'paid'">

              <div class="mb-3 font-weight-bold mainColor--text" style="font-size: 1rem;">How do optimization reviews work?</div>
              <div class="mb-3 mainColor--text">Not enough time to process and apply all the recommendations from the POP Content Brief? An Optimization Review makes your life easy. Our team will review your current POP report and provide prioritized, actionable recommendations to improve your page easily and fast.</div>
              <div class="mb-3 d-flex align-center gap10"><i class="material-icons-outlined" style="color: var(--v-profileAnchorColor-base);">email</i> <span class="mainColor--text">Delivered by email (PDF)</span></div>
              <div class="mb-3 d-flex align-center gap10"><i class="material-icons-outlined" style="color: var(--v-profileAnchorColor-base);">event_available</i> <span class="mainColor--text">Ready in one business day</span></div>
              <div class="mb-3" style="font-style: italic; color: var(--v-gray2Color-base);">Weekend orders delivered Monday</div>
              <div class="mb-1 mainColor--text"><b>Perfect if you:</b></div>
              <ul class="mb-3 mainColor--text" style="list-style: initial; padding-left: 18px;">
                <li class="mb-1">Want expert feedback on your current <b>POP report</b> or page</li>
                <li class="mb-1">Unsure which recommendations will have the biggest impact</li>
                <li>Want clear, actionable guidance to improve your pages SEO</li>
              </ul>
              <div class="mb-1 mainColor--text"><b>How it works</b></div>
              <ul class="mb-4 mainColor--text" style="list-style: initial; padding-left: 18px;">
                <li class="mb-1">You place your order</li>
                <li class="mb-1">We review your POP report</li>
                <li>You receive the review <b>by email</b> (PDF) within <b>one business day.</b> Also available in dashboard.</li>
              </ul>

              <div v-if="!hasEnoughCredits" class="mb-4" style="background-color: #FF57001A; color: #D07205; padding: 10px; border-radius: 5px;">
                Not enough credits to run the review. A review run costs <b>{{ credits_required }} credits</b>. Please top up your balance.
              </div>

              <div class="d-flex align-center gap5">
                <v-btn
                  outlined
                  small
                  color="mainColor"
                  class="button-with-icon mainColor--text text-none"
                  style="border-color: var(--v-grayColor-base);"
                  @click="() => {
                    $store.commit('setCurrentVideoTutorialToDisplay', {
                      title: 'Premium Review Optimization Report - Overview',
                      videoLink: 'https://www.youtube.com/embed/t3jR5guBUYU',
                      description: 'In this video, we walk you through the new Premium Optimization Review in POP. This report is a \'gift\' for non-SEO professionals, clients, or SEO assistants who find standard content briefs a bit tricky to implement. We show you how this report transforms complex data into easy-to-follow instructions to improve the SEO of your already existing web pages. Note: This report is specifically for improving the SEO of existing, published web pages.',
                      time: '1m 29s'
                    });
                  }"
                >
                  <span class="mr-1" style="padding-right: 1px; padding-right: 1px; display: inline-flex; align-items: center; justify-content: center; width: 16px; height: 16px; border-radius: 100%; background-color: var(--v-profileAnchorColor-base);">
                    <i class="material-icons" style="color: #fff; font-size: 0.78rem; margin-bottom: 1px;">videocam</i>
                  </span>
                  <span style="font-size: 0.8rem; font-weight: 700;">Sample report</span>
                </v-btn>
                <v-btn
                  v-if="hasEnoughCredits"
                  small
                  color="profileAnchorColor"
                  class="button-with-icon whiteColor--text text-none"
                  :disabled="newOrderLoading"
                  @click="activeOrder?.order_status === 'user_editing' ? (() => {showFormModal = true})() : newOrder()"
                >
                  <span style="font-size: 0.8rem; font-weight: 700;">Order for {{ credits_required }} POP credits</span>
                </v-btn>
                <v-btn
                  v-else
                  small
                  color="profileAnchorColor"
                  class="button-with-icon whiteColor--text text-none ml-1"
                  style="flex: 1;"
                  :to="`/useraccount/${ownerUser.id}?mainTab=billing-and-payments&subTab=buy-credits`"
                >
                  <span style="font-size: 0.8rem; font-weight: 700;">Buy more credits</span>
                </v-btn>
              </div>

            </template>

            <template v-else-if="activeOrder?.order_status === 'paid' && ['pending', 'in_progress'].includes(activeOrder?.fulfillement_status)">

              <div class="mb-3 font-weight-bold mainColor--text" style="font-size: 1rem;">Your optimization review is in progress</div>
              <div class="mainColor--text">Our team will review the on-page optimization you’ve done and provide targeted feedback to help you improve rankings faster.</div>

            </template>

            <template v-else-if="activeOrder?.order_status === 'paid' && ['completed'].includes(activeOrder?.fulfillement_status)">

              <div class="mb-3 font-weight-bold mainColor--text d-flex align-center gap10" style="font-size: 1rem;">
                <i class="material-icons" style="color: #12B267; font-size: 1.4rem;">check</i>
                Your optimization review is ready
              </div>
              <div class="mb-4 mainColor--text">You can download it here. We’ve also sent this review to your email.</div>

              <div class="d-flex align-center gap10">
                <div style="flex: 1;">
                  <v-btn
                    block
                    outlined
                    color="mainColor"
                    class="button-with-icon mainColor--text text-none"
                    style="border-color: var(--v-grayColor-base);"
                    to="/premium-reviews"
                  >
                    <span style="font-size: 0.85rem; font-weight: 700;">All reports</span>
                  </v-btn>
                </div>
                <div style="flex: 1;">
                  <v-btn
                    block
                    color="profileAnchorColor"
                    class="button-with-icon whiteColor--text text-none"
                    :disabled="newOrderLoading || !hasEnoughCredits"
                    @click.prevent="getPDFReport('top_level')"
                  >
                    <span style="font-size: 0.85rem; font-weight: 700;">Download review</span>
                  </v-btn>
                </div>
              </div>

            </template>

          </div>
        </v-list-item>
      </v-list>
    </v-menu>
    

    <v-menu
      v-else
      class="review-optimization-dropdown"
      open-on-hover
      :disabled="$store.getters.isDemoUser"
      offset-x
      offset-y
      style="border: 1px solid var(--v-gray12Color-base);"
      rounded
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          :loading="loading"
          block
          rounded outlined :x-small="$vuetify.breakpoint.lgAndDown"
          color="mainColor"
          class="button-with-icon text-none review-optimization-button not-needed"
          style="position: relative;"
          v-bind="attrs"
          v-on="on"
        >
          <span class="material-icons-outlined mr-1" style="font-size: 0.95rem !important; font-weight: initial;">diamond</span> 
          <span style="font-weight: 600;">Premium optimization review</span>
        </v-btn>
      </template>

      <v-list>
        <v-list-item style="width: 390px;">
        <div style="padding: 4px;">
          <div class="mainColor--text">Reviews are enabled when your score is below {{ MAX_POP_SCORE_FOR_REVIEW_OPTIMIZATION }}%, so our team can focus on real optimization opportunities.</div>
        </div>
        </v-list-item>
      </v-list>
    </v-menu>

    <form-modal
      :showFormModal="showFormModal"
      :score="score"
      :pageRun="pageRun"
      :credits_required="credits_required"
      :activeOrder="activeOrder"
      :existingOrdersCount="existingOrdersCount"
      @close="showFormModal = false"
      @refreshData="loadData($event)"
    />
  </div>
</template>

<script>
import moment from "moment";

import {
  MAX_POP_SCORE_FOR_REVIEW_OPTIMIZATION,
} from '@/consts/review_optimization.js'
import {
  downloadFile,
  downloadWordFile,
  downloadEditorReport,
  generateSchemasJSON,
  getReportHeaderImage,
} from "@/utils/download-reports.js"

import FormModal from './FormModal/Index.vue';

export default {
  components: { FormModal },
  props: [
    "pageRun",
    "score",
    "position",
    "isInCard",
  ],
  data() {
    return {
      loading: true,
      newOrderLoading: false,
      showFormModal: false,
      activeOrderId: null,
      credits_required: null,
      existingOrdersCount: 0,
    };
  },
  computed: {
    MAX_POP_SCORE_FOR_REVIEW_OPTIMIZATION() {
      return MAX_POP_SCORE_FOR_REVIEW_OPTIMIZATION
    },
    // This page run's orders, read from the shared store cache populated by the
    // batched fetch (one request covers every card) instead of a per-card request.
    orders() {
      return this.$store.getters.reviewOptimizationOrdersForPageRun(this.pageRun.id)
    },
    is_review_optimization_needed() {
      return this.score < MAX_POP_SCORE_FOR_REVIEW_OPTIMIZATION
    },
    activeOrder () {
      if (this.activeOrderId) {
        return this.orders.filter(order => order.id === this.activeOrderId)?.[0]
      }
      return null
    },
    ownerUser() {
      return this.$store.state.selectedSubAccountRelation || this.$store.state.user;
    },
    ownerAvailableCredits() {
      if (this.ownerUser) {
        return (
          this.ownerUser.monthlyCredits +
          this.ownerUser.remainedUniversalCredits
        );
      }
      return 0;
    },
    hasEnoughCredits() {
      try {
        return this.ownerAvailableCredits - this.credits_required >= 0;
      } catch {
        return false;
      }
    },
  },
  methods: {
    // Called once per card on mount. Reads this page run's orders from the shared
    // batched cache (a single request covers every card) and pulls the two
    // user-level values (pricing + paid count) from their deduped caches, so a
    // screen with N cards makes ~3 requests instead of 3N.
    loadOnMount () {
      this.loading = true;
      const ownerId = this.ownerUser.id;
      return Promise.all([
        this.$store.dispatch('ensureReviewOptimizationOrders', {
          ownerId,
          pageRunId: this.pageRun.id,
        })
          .then(() => {
            this.activeOrderId = this.orders?.[0]?.id
          }),
        this.$store.dispatch('loadReviewOptimizationPricingInfoCached')
          .then(price => {
            if (price != null) this.credits_required = price
          }),
        this.$store.dispatch('loadReviewOptimizationPaidCountCached', { ownerId })
          .then(total => {
            this.existingOrdersCount = total
          }),
      ])
        .finally(() => {
          this.loading = false;
        })
    },
    // Targeted refresh for THIS page run only (used after creating an order and by
    // the form modal's refreshData event) — one request, user-initiated, not a
    // mount-time storm. Writes the result into the shared store cache.
    loadData ({resetActiveOrderId = true} = {}) {
      this.loading = true;
      const ownerId = this.ownerUser.id;
      return this.$store.dispatch('getReviewOptimizationOrders', {
        user_id: ownerId,
        pageRunId: this.pageRun.id,
      })
        .then(response => {
          if (response.data && response.data.status == 'SUCCESS') {
            this.$store.commit('setReviewOptimizationOrdersForPageRun', {
              pageRunId: this.pageRun.id,
              orders: response.data.data || [],
            })
            if (resetActiveOrderId) {
              this.activeOrderId = this.orders?.[0]?.id
            }
          }
        })
        .then(() => this.$store.dispatch('loadReviewOptimizationPricingInfoCached', { force: true })
          .then(price => {
            if (price != null) this.credits_required = price
          }))
        .then(() => this.$store.dispatch('loadReviewOptimizationPaidCountCached', { ownerId, force: true })
          .then(total => {
            this.existingOrdersCount = total
          }))
        .finally(() => {
          this.loading = false;
        })
    },
    newOrder() {
      this.newOrderLoading = true;
      this.$store.dispatch('createReviewOptimizationOrder', {
        body: {
          pageRunId: this.pageRun.id,
        }
      })
        .then(response => {
          if (response.data && response.data.status == 'SUCCESS') {
            return this.loadData({resetActiveOrderId: true, silent: true})
          }
        })
        .then(() => {
          this.showFormModal = true
        })
        .finally(() => {
          this.newOrderLoading = false;
        })
    },
    getPDFReport(reportType, ommitInstructions = false) {
      if (!this.activeOrder?.id) return;

      const timestamp = moment().format("YYYY_M_D_h_mm_ss");
      this.$store.commit('showLoading');
      this.$store
        .dispatch('getReviewOptimizationOrderPDFReport', { orderId: this.activeOrder?.id, reportType: reportType, ommitInstructions })
        .then((response) => {
          const fileName = `${reportType}_${timestamp}`
          downloadFile(response.data, fileName)
        })
        .finally(() => {
          this.$store.commit('hideLoading');
        });
    },
  },
  mounted() {
    this.loadOnMount()
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .review-optimization-dropdown {
    width: 100%;
  }
}

.v-btn.review-optimization-button.not-needed {
  background-color: var(--v-gray12Color-base);
  border: none !important;
  cursor: initial;
  .v-btn__content span {
    color: #626262;
  }
}
</style>

<style lang="scss">
.v-btn.review-optimization-button {
  .diamond-icon {
    font-size: 1rem !important;
  }
}
.pagerun-card {
  .review-optimization-dropdown.is-top-right {
    .dropdown-menu {
      left: 100%;
    }
  }

  .v-btn.review-optimization-button {
    padding: 4px 6px !important;
    min-height: 36px;
  }

  .v-btn.review-optimization-button.in-progress {
    height: initial !important;
    max-height: 50px;
    padding: 4px 6px !important;

    .btn-dot {
      right: 5px !important;
    }
    .v-btn__content {
      justify-content: center;
      
    }
    .btn-text{
      max-width: 175px !important;
    }
    .diamond-icon {
      font-size: 1.2rem !important;
    }
  }
}
</style>
